// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"583":"f92c66d5","645":"e44fe8e5"}[chunkId] + ".chunk.css";
};